import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const HostGameCancellationDialog = ({
  game,
  open,
  onOpenChange,
  message,
  onMessageChange,
  onConfirm,
  isSubmitting = false,
  dateLabel = 'Date TBD',
  timeLabel = '',
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Cancel Game</AlertDialogTitle>
        <AlertDialogDescription>
          This marks the game canceled without deleting its history. Eligible affected players
          will be notified through their enabled channels.
        </AlertDialogDescription>
      </AlertDialogHeader>

      <div className="rounded-lg border border-zinc-200 bg-zinc-50 p-3 text-sm">
        <p className="font-semibold text-zinc-900">{game?.title || 'Untitled game'}</p>
        <p className="mt-1 text-zinc-600">
          {dateLabel}{timeLabel ? ` at ${timeLabel}` : ''}
        </p>
        <p className="mt-1 break-words text-zinc-600">
          {game?.location_name || game?.city || 'Location TBD'}
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="cancel-message">Cancellation message (optional)</Label>
        <Textarea
          id="cancel-message"
          placeholder="Add a short factual note for affected players"
          value={message}
          maxLength={200}
          onChange={(event) => onMessageChange(event.target.value)}
          disabled={isSubmitting}
          data-testid="cancel-message-input"
        />
        <p className="text-right text-xs text-zinc-500">{message.length}/200</p>
      </div>

      <AlertDialogFooter>
        <AlertDialogCancel disabled={isSubmitting} data-testid="cancel-dialog-cancel">
          Keep Game
        </AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          disabled={isSubmitting}
          className="bg-red-600 hover:bg-red-700"
          data-testid="cancel-dialog-confirm"
        >
          {isSubmitting ? 'Cancelling…' : 'Cancel Game'}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default HostGameCancellationDialog;
